import { parameterAffectPanelPrice, calculatePanel } from 'pu-data/Utils';

const railsAllSide = ['rails_left', 'rails_right', 'rails_top', 'rails_bottom']

// calculate panel length without rails
const panelLengthNoRails = (parameters) => {
  const boardLength = parseFloat(parameters.board_length)
  const quanityX = parseFloat(parameters.array_x_qty)
  const spacingX = parseFloat(parameters.array_spacing_x) || 0.0

  if (Number.isNaN(spacingX) || Number.isNaN(quanityX) || Number.isNaN(boardLength)) return null;

  return (boardLength * quanityX) + ((quanityX - 1) * spacingX)
}

// calculate panel width without rails
const panelWidthNoRails = (parameters) => {
  const boardWidth = parseFloat(parameters.board_width)
  const quanityY = parseFloat(parameters.array_y_qty)
  const spacingY = parseFloat(parameters.array_spacing_y) || 0.0

  if (Number.isNaN(boardWidth) || Number.isNaN(spacingY) || Number.isNaN(quanityY)) return null;

  return (boardWidth * quanityY) + ((quanityY - 1) * spacingY)
}

const arrayLongSides = (parameters) => {
  const length = panelLengthNoRails(parameters)
  const width = panelWidthNoRails(parameters)

  if (length !== null && width != null) {
    if (length > width) {
      return ['rails_left', 'rails_right'];
    }
    return ['rails_top', 'rails_bottom'];
  }
  return null;
}

const arrayShortSides = (parameters) => {
  const length = panelLengthNoRails(parameters)
  const width = panelWidthNoRails(parameters)

  if (length !== null && width != null) {
    if (length > width) {
      return ['rails_top', 'rails_bottom'];
    }
    return ['rails_left', 'rails_right'];
  }
  return null;
}

export const calculateRailWidths = (parameters) => {
  const sides = parameters.rails_sides;
  const width = parameters.rail_width || '';

  railsAllSide.forEach((side) => {
    // eslint-disable-next-line no-param-reassign
    parameters[side] = ''
  });

  if (sides === 'two_long_sides' && width !== '') {
    const longSides = arrayLongSides(parameters);
    if (longSides !== null) {
      longSides.forEach((side) => {
        // eslint-disable-next-line no-param-reassign
        parameters[side] = width;
      });
    }
  } else if (sides === 'two_short_sides' && width !== '') {
    const shortSides = arrayShortSides(parameters);
    if (shortSides !== null) {
      shortSides.forEach((side) => {
        // eslint-disable-next-line no-param-reassign
        parameters[side] = width;
      });
    }
  } else if (sides === 'all_four_sides' && width !== '') {
    railsAllSide.forEach((side) => {
      // eslint-disable-next-line no-param-reassign
      parameters[side] = width;
    });
  }
  return parameters;
}

export const mustUpdatePanelSize = (parameters, name) => {
  const alsoCalculatePanel = [
    'tab_route_panels',
    'v_score_panels',
    'tab_rout',
    'scoring',
    'add_rails_top_bottom',
    'add_rails_left_right',
    'rails_sides',
    'rail_width',
    'array_spacing_x_tab_rout',
    'array_spacing_x_vscore',
    'array_spacing_y_tab_rout',
    'array_spacing_y_vscore',
  ];
  return (
    (parameterAffectPanelPrice(name) || alsoCalculatePanel.indexOf(name) >= 0)
    && parameters.is_panelized === '0'
  );
};

export const updatePanelSize = (parameters) => {
  const result = calculatePanel(parameters);
  if (result) {
    parameters.array_up = result.array_up;
    parameters.array_x = result.array_x;
    parameters.array_y = result.array_y;
  }
  return parameters;
};
